import React, { Component } from "react";
import { CallAPI, GetCookieFunction } from '../../utils/util';
import { useSearchParams } from "react-router-dom";

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let [searchParams] = useSearchParams();
        return <Component {...props} searchParams={searchParams} />;
    }
    return ComponentWithRouterProp;
}

class DailyScheduleInner extends Component {
    constructor(props) {
        super(props);
        this.centerId = GetCookieFunction("Center").id;
        this.isAdmin = GetCookieFunction("User").type === "centeradmin" || GetCookieFunction("User").type === "executive";

        const dateParam = this.props.searchParams.get('date');
        const now = new Date();
        const todayStr = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`;
        this.state = {
            date: dateParam || todayStr,
            slots: [],
            availableMachines: 0,
            confirmCancelId: null,
            patientModal: null,
            loading: true
        };
    }

    componentDidMount() {
        this.loadDay();
        CallAPI({}, `scheduling/machines?centerId=${this.centerId}`, 'GET', (res) => {
            if (res.success) this.setState({ availableMachines: res.availableMachines });
        });
    }

    loadDay = () => {
        this.setState({ loading: true });
        CallAPI({}, `scheduling/daily?centerId=${this.centerId}&date=${this.state.date}`, 'GET', (res) => {
            if (res.success) {
                this.setState({ slots: res.data, loading: false });
            } else {
                this.setState({ loading: false });
            }
        }, () => this.setState({ loading: false }));
    }

    navigateDay = (direction) => {
        const parts = this.state.date.split('-');
        const d = new Date(parts[0], parts[1]-1, parts[2]);
        d.setDate(d.getDate() + direction);
        const ds = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
        this.setState({ date: ds }, this.loadDay);
    }

    handleCancel = (scheduleId) => {
        this.setState({ confirmCancelId: scheduleId });
    }

    handlePatientClick = (patientId, firstName, lastName) => {
        this.setState({ patientModal: { patientId, name: `${firstName} ${lastName}`, phone: "Loading...", email: "Loading..." } });
        CallAPI({}, `patients/${patientId}/complete`, 'GET', (res) => {
            this.setState({
                patientModal: {
                    patientId,
                    name: `${firstName} ${lastName}`,
                    phone: res.pNum || "—",
                    email: res.email || "—"
                }
            });
        });
    }

    confirmCancel = () => {
        const scheduleId = this.state.confirmCancelId;
        this.setState({ confirmCancelId: null });
        CallAPI({}, `scheduling/book/${scheduleId}?centerId=${this.centerId}`, 'DELETE', (res) => {
            if (res.success) this.loadDay();
        });
    }

    formatTime = (timeStr) => {
        if (!timeStr) return "";
        const [h, m] = timeStr.split(":");
        const hour = parseInt(h, 10);
        const ampm = hour >= 12 ? "PM" : "AM";
        const h12 = hour % 12 || 12;
        return `${h12}:${m} ${ampm}`;
    }

    formatDate = () => {
        const parts = this.state.date.split('-');
        const d = new Date(parts[0], parts[1]-1, parts[2]);
        return d.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
    }

    render() {
        const { slots, availableMachines } = this.state;
        const now = new Date();
        const todayStr = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`;
        const isToday = this.state.date === todayStr;
        const isPast = this.state.date < todayStr;

        return (
            <div className="ci-page" style={{maxWidth: '900px'}}>
                <div className="ci-header">
                    <h2>Daily Schedule</h2>
                    <p>Patients scheduled for today</p>
                    <a href={`/schedule?weekStart=${(() => {
                        const parts = this.state.date.split('-');
                        const d = new Date(parts[0], parts[1]-1, parts[2]);
                        const day = d.getDay();
                        const diff = day >= 6 ? 0 : -(day + 1);
                        d.setDate(d.getDate() + diff);
                        return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
                    })()}`} style={{fontSize: '13px', color: 'var(--primary)', marginTop: '6px', display: 'inline-block'}}>← Back to Weekly View</a>
                </div>

                {/* Day Navigator */}
                <div className="schedule-week-nav">
                    <button type="button" className="funnel-nav-arrow" onClick={() => this.navigateDay(-1)}>←</button>
                    <span className="schedule-week-label">
                        {this.formatDate()}
                        {isToday && <span style={{marginLeft: '8px', fontSize: '12px', color: 'var(--primary)', fontWeight: 400}}>(Today)</span>}
                    </span>
                    <button type="button" className="funnel-nav-arrow" onClick={() => this.navigateDay(1)}>→</button>
                </div>

                {this.state.loading ? (
                    <div style={{textAlign: 'center', padding: '40px', color: 'var(--text-muted)'}}>Loading...</div>
                ) : slots.length === 0 ? (
                    <div style={{textAlign: 'center', padding: '40px', color: 'var(--text-muted)'}}>No time slots configured.</div>
                ) : (
                    <div className="daily-schedule-slots">
                        {slots.map(slot => {
                            const count = slot.patients.length;
                            const isFull = count >= availableMachines && availableMachines > 0;
                            const isOverbooked = count > availableMachines;

                            return (
                                <div key={slot.slotId} className="daily-schedule-slot">
                                    <div className={`daily-schedule-slot-header ${isOverbooked ? 'overbooked' : isFull ? 'full' : 'available'}`}>
                                        <span className="daily-schedule-slot-time">
                                            {this.formatTime(slot.startTime)} – {this.formatTime(slot.endTime)}
                                        </span>
                                        <span className="daily-schedule-slot-count">
                                            {count}/{availableMachines} booked
                                        </span>
                                    </div>
                                    <div className="daily-schedule-patients">
                                        {slot.patients.length === 0 ? (
                                            <div className="daily-schedule-empty">No patients scheduled</div>
                                        ) : (
                                            slot.patients.map(p => (
                                                <div key={p.scheduleId} className="daily-schedule-patient">
                                                    <span className="daily-schedule-patient-name"
                                                        onClick={() => this.handlePatientClick(p.patientId, p.firstName, p.lastName)}>
                                                        {p.firstName} {p.lastName}
                                                    </span>
                                                    {p.patientCode && <span className="daily-schedule-code">{p.patientCode}</span>}
                                                    {this.isAdmin && !isPast && (
                                                        <button type="button" className="editable-delete-btn"
                                                            onClick={() => this.handleCancel(p.scheduleId)}>✕</button>
                                                    )}
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

                {/* Cancel Confirmation Modal */}
                {this.state.confirmCancelId && (
                    <div className="ci-modal-overlay" onClick={() => this.setState({ confirmCancelId: null })}>
                        <div className="ci-modal" onClick={(e) => e.stopPropagation()}>
                            <h3>Cancel Appointment</h3>
                            <p style={{fontSize: '14px', color: 'var(--text-secondary)', margin: '12px 0'}}>
                                Are you sure you want to cancel this appointment? The slot will be released for other patients.
                            </p>
                            <div className="ci-submit-row">
                                <button type="button" className="homeButton" onClick={() => this.setState({ confirmCancelId: null })}>Keep</button>
                                <button type="button" className="logSubmit" style={{width: 'auto', background: 'var(--danger)'}} onClick={this.confirmCancel}>Cancel Appointment</button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Patient Info Modal */}
                {this.state.patientModal && (
                    <div className="ci-modal-overlay" onClick={() => this.setState({ patientModal: null })}>
                        <div className="ci-modal" onClick={(e) => e.stopPropagation()}>
                            <h3>{this.state.patientModal.name}</h3>
                            <dl className="profile-dl" style={{margin: '12px 0'}}>
                                <dt>Phone</dt><dd>{this.state.patientModal.phone}</dd>
                                <dt>Email</dt><dd>{this.state.patientModal.email}</dd>
                            </dl>
                            <div className="ci-submit-row" style={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                                <button type="button" className="homeButton" style={{margin: 0, boxSizing: 'border-box'}} onClick={() => this.setState({ patientModal: null })}>Close</button>
                                <a href={`/patients/${this.state.patientModal.patientId}/checkin`} className="logSubmit" style={{width: 'auto', margin: 0, textDecoration: 'none', background: 'var(--success)', boxSizing: 'border-box'}}>Check In</a>
                                <a href={`/patients/${this.state.patientModal.patientId}/profile`} className="logSubmit" style={{width: 'auto', margin: 0, textDecoration: 'none', boxSizing: 'border-box'}}>View Profile</a>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default withRouter(DailyScheduleInner);
